import { Component, OnInit } from '@angular/core';
import { StateService } from 'src/app/core/state-manager/appstateservice';
import { PortalConfig, ResourcesType } from 'src/app/portal-config/shared/portal-config.model';
import { PortalConfigService } from 'src/app/portal-config/shared/portal-config.service';

@Component({
  selector: 'app-all-home',
  templateUrl: './all-home.component.html',
  styleUrls: ['./all-home.component.scss']
})
export class AllHomeComponent implements OnInit {

  bannerConfig: PortalConfig;
  resourcesType = ResourcesType;
  title = '';
  bgImage = '/assets/images/AllHomePageImg.jpg';
  portalbannerConfig:boolean=false;
  constructor(private portalService: PortalConfigService, private currentState: StateService ) { }
  ngOnInit() {
    this.getConfig();
  }

  ischeckPermissions(permission: string): boolean {  return this.currentState.permissionCheck(permission); }

  getConfig() {
    this.portalService.getConfig(this.resourcesType.Banner).subscribe(data => {
      this.bannerConfig = new PortalConfig().uiMapper(data);
      if (this.bannerConfig.resourcePath !== null && this.bannerConfig.resourcePath !== undefined) {
        this.title = this.bannerConfig.title;
        this.bgImage =  decodeURIComponent(decodeURIComponent(this.bannerConfig.resourcePath));
        this.portalbannerConfig=true;
      }
    });
  }
}
